import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const GraphicDesigningPage: React.FC = () => {
  return <ServicePageTemplate slug="graphic-designing" />;
};

export default GraphicDesigningPage;
